import {MutationTree} from "vuex";
import {TriggerImplementationState, TriggerImplementation} from "./model";

const mutations: MutationTree<TriggerImplementationState> = {
  setTriggerImplementations(state, triggerImplementations: TriggerImplementation[]) {
    state.triggerImplementations = triggerImplementations;
  },
  addTriggerImplementation(state, triggerImplementation: TriggerImplementation) {
    state.triggerImplementations.push(triggerImplementation);
  },
  deleteTriggerImplementation(state, id: string) {
    state.triggerImplementations = state.triggerImplementations.filter(triggerImplementation => triggerImplementation.id !== id);
  }
}

export default mutations;
